import { IcPhone } from '@assets/icons/40x40';
import { HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { useUpdateProcedureMutation } from '@services/data/procedure.api';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { ProcedureStep, ProcedureStepStateEnum } from '@/types/config/procedure.types';

import { useProcedureTabContext } from '../ProcedureTab';
import ProcedureInstructions from './ProcedureInstructions';
import StepActionButtons from './StepActionButtons';

type Props = {
  step: ProcedureStep;
  procedureId: string;
};

function PhoneCallStep({ step, procedureId }: Readonly<Props>) {
  const [updateProcedure] = useUpdateProcedureMutation();
  const { canManage, notificationId } = useProcedureTabContext();
  if (!canManage) {
    return <ProcedureInstructions instructions={step.instructions} />;
  }
  return (
    <>
      <VStack
        gap={2}
        paddingY={4}
        backgroundColor="neutral.700"
        width="100%"
        flex={step.instructions.length > 0 ? 0 : 1}
      >
        <Text>
          <FormattedMessage id="notification.procedure.step.type.PHONE_CALL.call" />
        </Text>
        <HStack gap={2}>
          <Icon as={IcPhone} color="neutral.300" boxSize="40px" />
          <Text>{step.phoneNumber ?? <FormattedMessage id="global.noInformation" />}</Text>
        </HStack>
      </VStack>
      <ProcedureInstructions instructions={step.instructions} />
      <StepActionButtons
        isMandatory={step.mandatory}
        procedureId={procedureId}
        stepRank={step.rank}
        onValidate={() =>
          updateProcedure({
            notificationId,
            procedureId,
            step: step.rank,
            state: ProcedureStepStateEnum.CONFIRMED,
          }).unwrap()
        }
      />
    </>
  );
}

export default memo(PhoneCallStep);
